<div class="icon-upload d-flex  align-items-center flex-column justify-content-around" (click)="file.click()">
    <span *ngIf="!filePath">+ Icon</span>
    <img class="img-fluid" *ngIf="filePath" [src]="api.getFileUrl(filePath)" alt="">
    <div [style.width.%]="progress" class="progress"></div>
</div>

<input type="file" (change)="iconUpload($event)" #file class="d-none">
